/* eslint-disable no-empty,@typescript-eslint/no-unused-vars,radix */

xplenty.directive('amazonRedshiftDestinationEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./amazon-redshift-destination-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          $scope.bodyDataOptions = {
            lineWrapping: true,
            lineNumbers: true,
            mode: 'text/x-sql',
          };

          $scope.onRecordsChange = (records) => {
            $scope.component.column_mappings = records;
          };

          if (typeof $scope.component.comp_rows === 'string') {
            try {
              $scope.component.comp_rows = parseInt($scope.component.comp_rows);
            } catch (e) {}
          }

          if (typeof $scope.component.max_errors === 'string') {
            try {
              $scope.component.max_errors = parseInt($scope.component.max_errors);
            } catch (e) {}
          }
        },
      ],
    };
  },
]);
